<mat-card>
    <div>Please enter all the relevent numbers for this equation</div>
    <mat-card-content >
      <mat-grid-list cols="6" [rowHeight]="50">
        <mat-grid-tile> Impact Slope </mat-grid-tile>
        <mat-grid-tile>  <input [(ngModel)]="linearCalModel.Impact_Slope" type="number"  placeholder="0"  required ngDefaultControl ></mat-grid-tile>
        <mat-grid-tile> Normal Slope </mat-grid-tile>
        <mat-grid-tile>  <input [(ngModel)]="linearCalModel.Normal_Slope" type="number"  placeholder="0"  required ngDefaultControl > </mat-grid-tile>            
        <mat-grid-tile> </mat-grid-tile>
        <mat-grid-tile> </mat-grid-tile>
      </mat-grid-list>
    </mat-card-content>        
  </mat-card>
  <mat-card>        
      <mat-card-content >
        <mat-grid-list cols="6" [rowHeight]="50">
          <mat-grid-tile> Impact Intercept </mat-grid-tile>
          <mat-grid-tile>  <input [(ngModel)]="linearCalModel.Impact_Intercept" type="number"  placeholder="0"  required ngDefaultControl > </mat-grid-tile>
          <mat-grid-tile> Normal Intercept </mat-grid-tile>
          <mat-grid-tile>  <input [(ngModel)]="linearCalModel.Normal_Intercept" type="number"  placeholder="0"  required ngDefaultControl > </mat-grid-tile>            
          <mat-grid-tile>  </mat-grid-tile>
          <mat-grid-tile>  </mat-grid-tile>
        </mat-grid-list>
      </mat-card-content>
      
    </mat-card>
    <mat-card>          
        <mat-card-content>
          <mat-grid-list cols="6" [rowHeight]="50">
            <mat-grid-tile></mat-grid-tile>
            <mat-grid-tile></mat-grid-tile>
            <mat-grid-tile></mat-grid-tile>
            <mat-grid-tile></mat-grid-tile>            
            <mat-grid-tile></mat-grid-tile>
            <mat-grid-tile></mat-grid-tile>
          </mat-grid-list>
        </mat-card-content>            
      </mat-card>